async function generateAiResponse(config, setMessages) {
	function updateMessage(text) {
		setMessages((prev) => [
			...prev.filter((msg) => msg.text !== "Thinking..."),
			{ role: "model", text: `<<-- ${text} -->>`, timestamp: Date.now() },
		]);
	}

	// Format chat history foe API request
	const data = config.map(({ role, text }) => ({ role, parts: [{ text }] }));

	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ contents: data }),
	};

	try {
		// Make the API call to get the AI's response
		const response = await fetch(
			process.env.REACT_APP_GEMINI_URL,
			requestOptions
		);

		const _data = await response.json();
		if (!response.ok)
			throw new Error(_data.error.message || "Something went wrong!");

		//  Clean and update chat with AI 's response
		const apiResponseText = _data?.candidates?.[0]?.content?.parts?.[0]?.text
			?.replace(/\*\*(.*?)\*\*/g, "$1")
			?.trim();

		updateMessage(apiResponseText);
	} catch (error) {
		console.log(error);
	}
}

export default generateAiResponse;
